import * as React from 'react'
import Layout from 'containers/Layout'
import Container from 'theme/atoms/Container'
import Story from 'theme/atoms/Story'
import Seo from 'theme/atoms/SEO'
import * as event from 'features/tracking/events'
import use404StaticBlock from 'utils/use404StaticBlock'
import DyProductSlider from 'theme/molecules/DyProductSlider'
import { dispatchEvent } from 'redux-ruleset'

export const ERROR_404 = () =>
  dispatchEvent({
    type: 'ERROR_404' as const
  })

declare global {
  interface RulesetDispatchEvents {
    'pages/404': ReturnType<typeof ERROR_404>
  }
}

type Props = {
  location: {
    pathname: string
    origin: string
  }
}

export default function Page404(props: Props) {
  React.useEffect(() => {
    ERROR_404()
    event.page404Reached(props.location.pathname)
  }, [])
  const staticBlock = use404StaticBlock()

  return (
    <Layout breadcrumbs={[{ label: 'Home', link: '/' }, { label: '404' }]}>
      <Seo
        canonicalUrl={`${props.location.origin}${props.location.pathname}`}
        location={props.location}
        title={staticBlock.title}
        description={staticBlock.description}
        type="website"
        seoNoIndex={true}
      />
      <Container>
        <div style={{ height: 40 }} />
        <Story story={staticBlock.story} cfId={staticBlock.contentfulID} />
        <DyProductSlider
          dySelector="wdv-2564_404page_fallback"
          title="Recommended Products"
          gridArea="404-dy-slider"
          layoutSize="normal"
        />
      </Container>
    </Layout>
  )
}
